import { IZoneData, Zones as ZonesLib } from "@package/map";
import Api from "Api";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { setTooltip } from "Redux/tooltipSlice";
import { selectZone } from "Redux/zonesSlice";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Pane } from "react-leaflet";

export default function Zones() {
  const dispatch = useAppDispatch();

  const {
    source,
    destination,
    level,
    visible: zonesVisible,
    zone,
    applySelecteds,
    autoApply,
    clearMode,
    clearModeUpdate,
  } = useAppSelector((state) => state.zones);
  const { surveyShowType, visible: surveysVisible } = useAppSelector((state) => state.surveys);
  const { zoneLayer } = useAppSelector((state) => state.layers);

  const handleOnClickZone = async (value: number[]) => {
    dispatch(selectZone(value));
  };

  return (
    <>
      {zonesVisible && (
        <ZonesLib
          zone={zone}
          level={level}
          zIndex={zoneLayer}
          selectionMode={(applySelecteds || autoApply) && surveysVisible && surveyShowType === 2}
          onHover={(value) => dispatch(setTooltip({ text: value ? `منطقه ${value?.zone.id} - سطح ${value?.zone.level}` : "" }))}
          onClick={(value) => handleOnClickZone(value)}
          zonesColor={[
            { zones: source, color: "#00a080" },
            { zones: destination, color: "#072040" },
          ]}
          clearMode={clearMode}
          clearModeUpdate={clearModeUpdate}
        />
      )}
    </>
  );
}
